import { VideoElement, VideoScene } from "../../../VideoEditor/types/Video";
import { v4 as uuid } from "uuid";
import { Template } from "../types";
import { defaultSequenceDuration } from "../../../constants";

export function generateKnowledgeSharingCheckKnowledgeTemplate(
  data: Template,
  order: number,
  t: any
) {
  const sceneId = uuid();
  const scene: VideoScene = {
    id: sceneId,
    backgroundColor: "#fff",
    duration: defaultSequenceDuration,
    order,
    name: t("themi-builder.template.check-knowledge.scene-name"),
    enableCollaboration: true,
    start_time: 0,
    elements: [],
  };

  const firstElement: VideoElement = {
    id: uuid(),
    scene_id: sceneId,
    text: `<p style="font-family: Arial; font-size: 4.57cqw;"><strong>${t(
      "themi-builder.template.check-knowledge.title"
    )}</strong></p>`,
    type: "text",
    order: 0,
    states: [
      {
        id: uuid(),
        top: 21.21,
        left: 35.35,
        scale: 1,
        width: 636.3000000000001,
        height: 57.834724540901504,
        duration: defaultSequenceDuration,
        rotation: 0,
        start_time: 0,
      },
    ],
  };

  const secondElement: VideoElement = {
    id: uuid(),
    scene_id: sceneId,
    // Check your audience's knowledge on this topic by asking them questions. You can find the results in your Themi insights.
    text: `<p style="font-family: Arial; font-size: 2cqw; color: rgba(97, 97, 97, 1);">${t(
      "themi-builder.template.check-knowledge.description"
    )}</p>`,
    type: "text",
    order: 1,
    states: [
      {
        id: uuid(),
        top: 84.84,
        left: 35.35,
        scale: 1,
        width: 636.3000000000001,
        height: 44.85141903171953,
        duration: defaultSequenceDuration,
        rotation: 0,
        start_time: 0,
      },
    ],
  };

  const thirdElement: VideoElement = {
    id: uuid(),
    scene_id: sceneId,
    type: "poll",
    order: 2,
    title: "",
    config: {
      fillColor: "#fff",
      strokeSize: 1,
      fillOpacity: 100,
      strokeColor: "#000",
      strokeLineCap: "round",
      strokeOpacity: 100,
    },
    states: [
      {
        id: uuid(),
        top: 146.62186978297163,
        left: 36.26377295492487,
        scale: 1,
        width: 255,
        height: 230,
        duration: defaultSequenceDuration,
        rotation: 0,
        start_time: 0,
      },
    ],
    choices: [
      {
        id: uuid(),
        text: "Click here",
        is_correct: false,
      },
      {
        id: uuid(),
        text: "Click here",
        is_correct: false,
      },
    ],
    subtype: "multiple-choice",
    touched: true,
    subtitle: "",
    disclaimer: "",
  };

  const fourthElement: VideoElement = {
    id: uuid(),
    scene_id: sceneId,
    type: "poll",
    order: 2,
    title: "",
    config: {
      fillColor: "#fff",
      strokeSize: 1,
      fillOpacity: 100,
      strokeColor: "#000",
      strokeLineCap: "round",
      strokeOpacity: 100,
    },
    states: [
      {
        id: uuid(),
        top: 147.03224123539232,
        left: 353.0116861435726,
        scale: 1,
        width: 255,
        height: 230,
        duration: defaultSequenceDuration,
        rotation: 0,
        start_time: 0,
      },
    ],
    choices: [
      {
        id: uuid(),
        text: "Click here",
        is_correct: false,
      },
      {
        id: uuid(),
        text: "Click here",
        is_correct: false,
      },
    ],
    subtype: "multiple-choice",
    touched: true,
    subtitle: "",
    disclaimer: "",
  };

  const scenes: VideoScene[] = [scene];

  const elements: VideoElement[] = [
    firstElement,
    secondElement,
    thirdElement,
    fourthElement,
  ];

  return { scenes, elements };
}
